import React from 'react';
import { motion } from 'framer-motion';
import '../styles/PageTopIntro.css';
import '../styles/Contact.css';
import Navbar from '../components/layout/Navbar';
import Footerbar from '../components/layout/Footerbar';
import PageTopIntroLine from '../components/layout/PageTopIntroLine';
import ARBackground from '../components/animations/ARBackground';
import { useWindowScrollProgressRef } from '../hooks/useWindowScrollProgressRef';
import {
  sectionStagger,
  fadeUpItem,
  revealViewport,
} from '../components/animations/animationVariants';

const Contact = () => {
  const bgScrollRef = useWindowScrollProgressRef();

  return (
    <>
      <ARBackground scrollProgressRef={bgScrollRef} />
      <Navbar />
      <div className="contact-page">
        <header className="page-top-intro">
          <PageTopIntroLine text="BIIYEON — 문의·협업 채널" />
        </header>

        <section className="contact-hero">
          <motion.span
            className="section-eyebrow"
            variants={fadeUpItem}
            initial="hidden"
            whileInView="visible"
            viewport={revealViewport}
          >
            04 / Contact
          </motion.span>
          <motion.h2
            className="contact-page-title"
            variants={fadeUpItem}
            initial="hidden"
            whileInView="visible"
            viewport={revealViewport}
          >
            Let&apos;s Talk<em className="contact-page-title-dot">.</em>
          </motion.h2>
          <motion.p
            className="contact-page-lede"
            variants={fadeUpItem}
            initial="hidden"
            whileInView="visible"
            viewport={revealViewport}
          >
            프로젝트 협업 제안, 제휴·파트너십, 서비스·기술에 대한 궁금한 점
            <br />
            어떤 이야기든 환영합니다.
            <br />
            편한 채널로 연락 주시거나 아래 양식을 남겨 주세요.
            <br />
            확인 후 빠르게 답장 드리겠습니다.
          </motion.p>
        </section>

        <motion.div
          className="contact-channels"
          variants={sectionStagger}
          initial="hidden"
          whileInView="visible"
          viewport={revealViewport}
        >
          <motion.a
            className="contact-channel"
            href="https://www.instagram.com/biiyeon/"
            target="_blank"
            rel="noreferrer"
            variants={fadeUpItem}
          >
            <span className="contact-channel__label">INSTAGRAM</span>
            <span className="contact-channel__value">@biiyeon</span>
            <span className="contact-channel__hint">소식과 작업 기록을 확인해 보세요</span>
            <span className="contact-channel__arrow" aria-hidden="true">→</span>
          </motion.a>
        </motion.div>

        <motion.section
          className="contact-form-section"
          variants={fadeUpItem}
          initial="hidden"
          whileInView="visible"
          viewport={revealViewport}
        >
          <h3 className="contact-title">메시지 남기기</h3>
          <p className="contact-subtitle">
            전하고 싶은 이야기를 자유롭게 적어 주세요. 협업 제안·질문·간단한 인사 모두 괜찮습니다.
          </p>

          <form className="contact-form">
            <div className="form-row">
              <label>
                성함
                <input type="text" />
              </label>
              <label>
                연락처
                <input type="text" />
              </label>
            </div>
            <label>
              문의 내용
              <textarea rows="5" />
            </label>
            <div className="checkbox-row">
              <input type="checkbox" id="agree" />
              <label htmlFor="agree">
                개인정보 수집·이용에 동의합니다.
              </label>
            </div>
            <button type="submit" className="submit-btn">
              문의 남기기<span className="btn-arrow" aria-hidden="true">→</span>
            </button>
          </form>
        </motion.section>
      </div>

      <Footerbar />
    </>
  );
};

export default Contact;
